export const brandCaptionLowerThirdPrimary = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
